import { Outlet } from "react-router-dom";
import { Header } from "@/sections/Header";
import { Footer } from "@/sections/Footer";
import ChatPopup from "@/components/common/chatpopup";

export default function RootLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <ChatPopup />
      <Footer />
    </div>
  );
} 